import { Injector } from '@angular/core';
import { BaseNode } from './BaseNode';
import { FormlyView } from '../Data/FormlyView';
import { CONTAINSOPERATOR} from '../Constants';
import { DummyNode } from './DummyNode';
export class SimpleSearchNode extends BaseNode {

  operatorSelected: string = CONTAINSOPERATOR;
  entityName?: string; 
  constructor(injector: Injector, data: any, labelTemplate: string, entity?: string) {
    super(injector, data, labelTemplate);
    this.entityName = entity;
    if  (data instanceof FormlyView) {
      this.children?.push(new DummyNode());
    }
  }

}
